import {
  Select as ShadcnSelect,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { cn } from "@/utils/cn";
import { SelectProps } from "./Select.types";

const baseStyles = "w-full";
const sizeStyles = {
  sm: "h-8 text-sm",
  md: "h-10 text-base",
  lg: "h-12 text-lg",
};

const neumorphStyles =
  "border border-[--color-neutral] dark:border-[--color-neutral-dark] dark:bg-[--secondary-900] dark:text-white";

export const Select: React.FC<SelectProps> = ({
  label,
  options,
  value,
  onChange,
  placeholder = "Seleccionar",
  selectSize = "md",
  neumorph = false,
  className,
  ...props
}) => {
  const triggerClass = cn(
    baseStyles,
    sizeStyles[selectSize],
    neumorphStyles,
    className
  );

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium mb-1">
          {label}
        </label>
      )}
      <ShadcnSelect value={value} onValueChange={onChange} {...props}>
        <SelectTrigger className={triggerClass}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className={neumorphStyles}>
          {options.length === 0 ? (
            <SelectItem value="no-data" disabled className="text-center justify-center opacity-50 cursor-not-allowed">
              Sin datos
            </SelectItem>
          ) : (
            options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))
          )}
        </SelectContent>
      </ShadcnSelect>
    </div>
  );
};
